import React from 'react'
import { Link } from 'gatsby'
import { Button, Box, Heading, Text } from 'theme-ui'

/**
 * Shadow me to add your own content
 */

const styles = {
  author: {
    display: `inline-block`,
    color: `alpha`
  },
  occupation: {
    mb: 4
  },
  specialty: {
    color: `text`,
    mb: 4
  }
}

export default () => (
  <>
    <Heading variant='h1'>
      Hi, I'm <Text sx={styles.author}>Suresh K. Mukhiya</Text>.
    </Heading>
    <Heading variant='h1' sx={styles.occupation}>
      PhD, Software Engineer
    </Heading>
    <Heading variant='h4' sx={styles.specialty}>
    Software Architecture, Frontend Technologies, Data Analytics, NLP and Photography, fascinates me. 
    </Heading>
    <Box variant='buttons.group'>
      <Button as={Link} to='/contact'>
        Contact Me
      </Button>
      <Button variant='white' as={Link} to='/about-me'>
        About Me
      </Button>
    </Box>
  </>
)
